import {
    Setting,
    UserAuthState,
} from '@app-state';
import {
    FeatureFlag,
    IModalAdditionalSettings,
    IPackage,
    ModalResultType,
    NugetType,
} from '@models';
import { ODataGridComponent } from '@pages/generics/grid';
import { CommonNugetService } from '@services';

import cloneDeep from 'lodash-es/cloneDeep';
import { merge } from 'rxjs';

import {
    NugetUploadModalComponent,
    NugetVersionsModalComponent,
    NugetViewerModalComponent,
} from '../../modals';

export abstract class NugetGridComponent extends ODataGridComponent<IPackage, string> {
    public createPermission = '';
    public abstract type: NugetType;

    public get showUploadButton() {
        if (
            this._appState.user.authState === UserAuthState.LoggedInAsTenant &&
            this.type === NugetType.Libraries &&
            this._appState.settings.get(Setting.librariesUseSharedFeed) &&
            !this._appState.settings.get(Setting.librariesAllowTenantPublish)
        ) {
            return false;
        }

        return true;
    }

    private _commonNugetService = this._injector.get<CommonNugetService>(CommonNugetService);

    public get showViewer(): boolean {
        return this.type === NugetType.Packages &&
            this._appState.settings.isFeatureEnabled(FeatureFlag.PackagesViewer) &&
            this._commonNugetService.isNugetDownloadEnabled(this.type);
    }

    public showVersions(entry: IPackage) {
        let clone: IPackage | undefined;
        if (entry) {
            clone = cloneDeep(entry);
        }

        this._modal
            .openModal(NugetVersionsModalComponent, clone, {
                data: {
                    type: this.type,
                },
            })
            .afterClosedResult()
            .subscribe(res => {
                switch (res.type) {
                    case ModalResultType.Remove:
                        this._refresh$.next();
                        break;
                }
            });
    }

    public openUploadModal() {
        const modalRef = this._modal
            .openModal(NugetUploadModalComponent, null, {
                data: {
                    type: this.type,
                },
            });

        merge(
            modalRef.customEvent,
            modalRef.afterClosedResult(),
        ).subscribe(res => {
            if ([ModalResultType.Add, ModalResultType.Update].includes(res.type)) {
                this._refresh$.next();
            }
        });
    }

    public openNugetViewerModal(entry?: IPackage) {

        const modalOptions: IModalAdditionalSettings = {
            data: {
                type: this.type,
            },
            size: 'xl',
            position: {
                top: '0px',
            },
            additionalClasses: ['nuget-viewer'],
            overflow: false,
        };

        this._modal.openModal(NugetViewerModalComponent, entry, modalOptions);
    }
}
